import { Link } from "react-router-dom";
import { RTable } from "../../Component/Table/RTable";
import { TableStructure } from "../../Component/Table/TableStructureInterface";
import { PageHeader } from "../../Component/Common/Headers";

export const SecurityLog = () => {

  const tableStructure: TableStructure[] = [
    {
      name: "id", render: (data: any, index: any) => {
        return index;
      },
    },
    {
      name: "What", render: (data: any, index: any) => {
        return `${data.resion}`;
      },
    },
    { name: "CreatedBy", key: "userName" },
    { name: "CreatedAt", key: "createdAt" },
    {
      name: "Modification", render: (data: any) => {
        return <><p>{JSON.stringify(data.data)}</p></>
      }
    }
  ];

  return (
    <div className="container">
      <PageHeader
        title="Security Logs"
        subtitle="Monitor system changes and user activity"
      />
      <RTable deleteUrl="Log/softDelete" api="log/withPagination" tableStructure={tableStructure} />
    </div>
  );
};
